// The word being typed, apart from the DOM so it can be unit-tested (test/draft.test.ts).

import { WORD_LENGTH } from "../src/protocol";

/**
 * The word being typed: one slot per letter and a cursor. Clicking a tile (or the arrow keys)
 * moves the cursor, so a letter already found can go straight to its place.
 */
export class Draft {
  private readonly slots: string[] = Array<string>(WORD_LENGTH).fill("");
  /** Slot the next letter goes to; WORD_LENGTH when every slot is filled. */
  cursor = 0;

  get letters(): readonly string[] {
    return this.slots;
  }

  get word(): string {
    return this.slots.join("");
  }

  get complete(): boolean {
    return this.slots.every((letter) => letter !== "");
  }

  clear(): void {
    this.slots.fill("");
    this.cursor = 0;
  }

  select(index: number): void {
    this.cursor = Math.max(0, Math.min(WORD_LENGTH - 1, index));
  }

  move(step: number): void {
    this.select(Math.min(this.cursor, WORD_LENGTH - 1) + step);
  }

  type(letter: string): void {
    if (this.cursor >= WORD_LENGTH) return;
    this.slots[this.cursor] = letter;
    // On to the next empty slot to the right, else the first empty one, else the end.
    const after = this.slots.findIndex((l, i) => i > this.cursor && l === "");
    const first = this.slots.indexOf("");
    this.cursor = after >= 0 ? after : first >= 0 ? first : WORD_LENGTH;
  }

  backspace(): void {
    if (this.cursor < WORD_LENGTH && this.slots[this.cursor] !== "") {
      this.slots[this.cursor] = "";
      return;
    }
    if (this.cursor === 0) return;
    this.cursor--;
    this.slots[this.cursor] = "";
  }
}
